<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
    :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/coupons'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col style="min-height: 60vh">
              <ValidationProvider
                ref="status"
                rules="required"
                v-slot="{ errors }"
              >
<!--                <v-select-->
<!--                  :error-messages="errors"-->
<!--                  v-model="data.users"-->
<!--                  label="Usuarios"-->
<!--                  :items="users"-->
<!--                  item-value="_id"-->
<!--                  :item-text="(row)=>`${row.name || ''} ${row.last_name || ''}`"-->
<!--                  multiple-->
<!--                  solo-->
<!--                    hide-details="auto"-->
<!--                    class="input-base"-->
<!--                    append-icon="$caretDownFormIcon"-->
<!--                >-->
<!--                  <template slot="no-data">-->
<!--                    <v-alert :value="true"> No hay datos a mostrar </v-alert>-->
<!--                  </template>-->
<!--                </v-select>-->
                <v-select
                    ref="userSelect"
                    v-model="data.users"
                    :items="visibleUsers"
                    :item-text="(row) => `${row.name || ''} ${row.last_name || ''}`"
                    item-value="_id"
                    multiple
                    solo
                    hide-details="auto"
                    class="input-base"
                    :error-messages="errors"
                    label="Buscar usuarios"
                    append-icon="$caretDownFormIcon"
                    :search-input.sync="searchUser"
                    attach
                >
                  <template #prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                            v-model="searchUser"
                            placeholder="Buscar"
                            hide-details
                            solo
                            dense
                        />
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2" />
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import GoogleMapLoader from "@/components/maps/GoogleMapLoader";

export default {
  mixins: [CrudFormMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    CrudForm,
    GoogleMapLoader
  },

  computed: {
    ...mapState({
      status: state => state.Rent_orders.status,
      rawUsers: state => state.Users.list
    }),
    users() {
      return this.rawUsers
          .filter(u => u.name && u.name.trim() !== "")
          .sort((a, b) => a.name.trim().localeCompare(b.name.trim(), 'es', { sensitivity: 'base' }));
    },
    selectedUsers() {
      return this.rawUsers.filter(u => this.data.users.includes(u._id));
    },
    filteredUsers() {
      return this.rawUsers
          .filter(u => u.name && u.name.trim() !== "")
          .filter(u => {
            const full = `${u.name} ${u.last_name}`.toLowerCase();
            return full.includes(this.searchUser.trim().toLowerCase());
          })
          .sort((a, b) =>
              a.name.trim().localeCompare(b.name.trim(), "es", { sensitivity: "base" })
          );
    },
    visibleUsers() {
      const selectedIds = this.data.users;

      if (this.searchUser.trim()) {
        // Si hay búsqueda, mostrar solo los que coinciden y no están seleccionados
        return this.rawUsers
            .filter(u => u.name && u.name.trim() !== "")
            .filter(u => {
              const full = `${u.name} ${u.last_name}`.toLowerCase();
              return full.includes(this.searchUser.trim().toLowerCase());
            })
            .filter(u => !selectedIds.includes(u._id))
            .sort((a, b) =>
                a.name.trim().localeCompare(b.name.trim(), "es", { sensitivity: "base" })
            );
      } else {
        // Si no hay búsqueda, mostrar todos los seleccionados + todos los disponibles
        const map = new Map();
        [...this.selectedUsers, ...this.users].forEach(u => {
          map.set(u._id, u);
        });
        return Array.from(map.values());
      }
    }
  },
  async created() {
    if (this.$route.params.coupon_id) {
      this.data.coupon_id = this.$route.params.coupon_id;
    }
    this.$store.dispatch("Users/getListAll", { show_all: "enable", without_coupon: this.$route.params.coupon_id });
  },
  data() {
    return {
      parentStoreName: "Coupons",
      parentUrlKey: "coupon_id",
      storeName: "User_coupons",
      title: "Cupon de Usuario",
      data: {
        coupon_id: "",
        users: []
      },
      searchUser: "",
    };
  },
  watch: {},
  methods: {},
  mounted() {
    this.$watch(
        () => this.$refs.userSelect && this.$refs.userSelect.isMenuActive,
        (isOpen) => {
          if (isOpen === false) {
            this.searchUser = "";
          }
        }
    );
  },
  beforeDestroy() {
    this.$store.dispatch("Users/clearList");
  }
};
</script>
